/**
 * Geteilte, häufig genutzte Admin-Labels (Namespace `common`).
 * Ergänzt die in src/i18n/index.ts vorhandenen common-Keys.
 */
export const common = {
  de: {
    common: {
      save: 'Speichern',
      saving: 'Speichern…',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      remove: 'Entfernen',
      edit: 'Bearbeiten',
      view: 'Anzeigen',
      add: 'Hinzufügen',
      create: 'Erstellen',
      update: 'Aktualisieren',
      search: 'Suchen',
      filter: 'Filtern',
      clear: 'Zurücksetzen',
      loading: 'Lädt…',
      saved: 'Gespeichert',
      error: 'Fehler',
      errorGeneric: 'Ein Fehler ist aufgetreten',
      success: 'Erfolg',
      confirm: 'Bestätigen',
      yes: 'Ja',
      no: 'Nein',
      ok: 'OK',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Vorherige',
      open: 'Öffnen',
      all: 'Alle',
      none: 'Keine',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      date: 'Datum',
      time: 'Zeit',
      status: 'Status',
      notes: 'Notizen',
      actions: 'Aktionen',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      required: 'Pflichtfeld',
      optional: 'Optional',
      selectDate: 'Datum auswählen',
      selectTime: 'Zeit auswählen',
      noResults: 'Keine Ergebnisse',
      retry: 'Erneut versuchen',
      copy: 'Kopieren',
      copied: 'Kopiert',
      download: 'Herunterladen',
      upload: 'Hochladen',
      language: 'Sprache',
    },
  },
  es: {
    common: {
      save: 'Guardar',
      saving: 'Guardando…',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      remove: 'Quitar',
      edit: 'Editar',
      view: 'Ver',
      add: 'Añadir',
      create: 'Crear',
      update: 'Actualizar',
      search: 'Buscar',
      filter: 'Filtrar',
      clear: 'Restablecer',
      loading: 'Cargando…',
      saved: 'Guardado',
      error: 'Error',
      errorGeneric: 'Se ha producido un error',
      success: 'Éxito',
      confirm: 'Confirmar',
      yes: 'Sí',
      no: 'No',
      ok: 'OK',
      close: 'Cerrar',
      back: 'Atrás',
      next: 'Siguiente',
      previous: 'Anterior',
      open: 'Abrir',
      all: 'Todos',
      none: 'Ninguno',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      date: 'Fecha',
      time: 'Hora',
      status: 'Estado',
      notes: 'Notas',
      actions: 'Acciones',
      active: 'Activo',
      inactive: 'Inactivo',
      required: 'Obligatorio',
      optional: 'Opcional',
      selectDate: 'Seleccionar fecha',
      selectTime: 'Seleccionar hora',
      noResults: 'Sin resultados',
      retry: 'Reintentar',
      copy: 'Copiar',
      copied: 'Copiado',
      download: 'Descargar',
      upload: 'Subir',
      language: 'Idioma',
    },
  },
};
